var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.75H4.58333H19.25",
    stroke: "black",
    strokeWidth: 1.87305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4173 5.7474V19.1641C17.4173 19.6724 17.2242 20.1599 16.8803 20.5194C16.5365 20.8788 16.0702 21.0807 15.584 21.0807H6.41732C5.93109 21.0807 5.46477 20.8788 5.12096 20.5194C4.77714 20.1599 4.58398 19.6724 4.58398 19.1641V5.7474M7.33398 5.7474V3.83073C7.33398 3.3224 7.52714 2.83489 7.87096 2.47544C8.21477 2.116 8.68109 1.91406 9.16732 1.91406H12.834C13.3202 1.91406 13.7865 2.116 14.1303 2.47544C14.4742 2.83489 14.6673 3.3224 14.6673 3.83073V5.7474",
    stroke: "black",
    strokeWidth: 1.87305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.ce9fadaaa4acbfd3c502ecbc31315d30.svg";
export { ForwardRef as ReactComponent };